<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import Icon from '@/components/Icon.vue'
import { useUi } from '@/stores/ui'
import { useTransitions } from '@/stores/transitions'

const ui = useUi()
const tx = useTransitions()

const person = computed(() => ui.knockFor)
const dnd = computed(() => person.value?.mode === 'deep' || person.value?.mode === 'break')
const presets = ['got 2 min?', 'quick question', 'can I grab you?', 'no rush — when free']
const msg = ref('got 2 min?')

watch(person, (p) => { if (p) msg.value = 'got 2 min?' })

function send() {
  if (!person.value) return
  tx.knock(person.value, msg.value)
  ui.closeKnock()
}
</script>

<template>
  <div v-if="person" class="modal-back in" @mousedown.self="ui.closeKnock()">
    <div class="modal modal--knock" role="dialog" aria-modal="true">
      <div class="knock">
        <button class="modal-x" @click="ui.closeKnock()"><Icon name="x" :size="18" /></button>
        <div class="knock__ico"><Icon name="knock" :size="24" /></div>
        <h3>Knock on {{ person.short }}’s door</h3>
        <p class="txt-mid">
          {{ dnd
            ? `They’re ${person.mode === 'break' ? 'on a break' : 'in Deep work'} — your knock will queue, not interrupt.`
            : 'A soft chime on their end. One tap to accept or decline.' }}
        </p>
        <div class="knock__presets">
          <button v-for="t in presets" :key="t" class="knock__preset" @click="msg = t">{{ t }}</button>
        </div>
        <input v-model="msg" class="knock__input" placeholder="say something…" @keydown.enter="send" />
        <button class="btn btn--primary btn--lg" style="width:100%" @click="send">
          <Icon name="knock" :size="16" /> {{ dnd ? 'Queue the knock' : 'Send knock' }}
        </button>
      </div>
    </div>
  </div>
</template>
